export class Fax {
    id: number;
    number: string;
    name: string;
    type: string;
    email: string;

    pbxId: number;
}
